<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
            <div class="form-group col-xs-6">
                <label>From</label>
                <input placeholder="Now" type="number" class="form-control" v-model="paramsFromDistance"/>
                <select v-show="showFrom" type="number" class="form-control" v-model="paramsFromUnit">
                    <option value="d">Days Ago</option>
                    <option value="w">Weeks Ago</option>
                    <option value="M">Months Ago</option>
                    <option value="y">Years Ago</option>
                    <option value="h">Hours Ago</option>
                    <option value="m">Minutes Ago</option>
                </select>
                <div v-show="showFrom" class="form-group">
                    <input type="checkbox" v-model="paramsFromRound"/><label>Round</label>
                </div>
            </div>
            <div class="form-group col-xs-6 ">
                <label>To</label>
                <input placeholder="Now" type="number" class="form-control" v-model="paramsToDistance"/>
                <select v-show="showTo" type="number" class="form-control" v-model="paramsToUnit">
                    <option value="d">Days Ago</option>
                    <option value="w">Weeks Ago</option>
                    <option value="M">Months Ago</option>
                    <option value="y">Years Ago</option>
                    <option value="h">Hours Ago</option>
                    <option value="m">Minutes Ago</option>
                </select>
                <div v-show="showTo" class="form-group">
                    <input type="checkbox" v-model="paramsToRound"/><label>Round</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['params'],
        name: 'SearchDateRangeRelative',
        data () {
            return {
            }
        },
        computed: {
            showFrom () {
                return this.paramsFromDistance !== ''
            },
            showTo () {
                return this.paramsToDistance !== ''
            },
            paramsFromDistance: {
                get () {
                    if (this.params === null) {
                        return ''
                    }

                    return this.params.from ? this.params.from.distance || '' : ''
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: newValue ? {
                            distance: newValue,
                            unit: this.paramsFromUnit,
                            round: this.paramsFromRound
                        } : '',
                        to: this.params.to
                    })
                }
            },
            paramsFromUnit: {
                get () {
                    if (this.params === null) {
                        return 'd'
                    }

                    return this.params.from ? this.params.from.unit || 'd' : 'd'
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: {
                            distance: this.paramsFromDistance,
                            unit: newValue,
                            round: this.paramsFromRound
                        },
                        to: this.params.to
                    })
                }
            },
            paramsFromRound: {
                get () {
                    if (this.params === null) {
                        return true
                    }

                    return (this.params.from && this.params.from.round !== undefined) ? this.params.from.round : true
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: {
                            distance: this.paramsFromDistance,
                            unit: this.paramsFromUnit,
                            round: newValue
                        },
                        to: this.params.to
                    })
                }
            },
            paramsToDistance: {
                get () {
                    if (this.params === null) {
                        return ''
                    }

                    return this.params.to ? this.params.to.distance || '' : ''
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: this.params.from,
                        to: newValue ? {
                            distance: newValue,
                            unit: this.paramsToUnit,
                            round: this.paramsToRound
                        } : ''
                    })
                }
            },
            paramsToUnit: {
                get () {
                    if (this.params === null) {
                        return 'd'
                    }

                    return this.params.to ? this.params.to.unit || 'd' : 'd'
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: this.params.from,
                        to: {
                            distance: this.paramsToDistance,
                            unit: newValue,
                            round: this.paramsToRound
                        }
                    })
                }
            },
            paramsToRound: {
                get () {
                    if (this.params === null) {
                        return true
                    }

                    return (this.params.to && this.params.to.round !== undefined) ? this.params.to.round : true
                },
                set (newValue) {
                    this.$emit('update:params', {
                        from: this.params.from,
                        to: {
                            distance: this.paramsToDistance,
                            unit: this.paramsToUnit,
                            round: newValue
                        }
                    })
                }
            }
        },
        methods: {},
        created () {
            if (this.params === null) {
                this.$emit('update:params', {
                    from: '',
                    to: ''
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchDateRangeRelative.vue?d634292c